// extracted by mini-css-extract-plugin
module.exports = {"custom-border-radius":"multiColumn_custom-border-radius__fktgr"};